import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { PayService } from '../service/pay.service';
import { BalanceSyncService } from '../service/security/balance-sync.service';
import { BalanceSocketMessage, RealtimeBalanceService } from '../service/security/realtime-balance.service';
import { UserSessionService } from '../user-session.service';
import { CaissePrelevement } from '../models/caissePrelevement';
import { CaisseDepot } from '../models/caisseDepot';

@Component({
  selector: 'app-bspace',
  templateUrl: './bspace.component.html',
  styleUrls: ['./bspace.component.css'],
  standalone: false
})
export class BspaceComponent implements OnInit, OnDestroy {
  transaction: UntypedFormGroup;
  deposit: UntypedFormGroup;
  retrait: UntypedFormGroup;
  username: string;
  error4: boolean = false;
  error3: boolean = false;
  error2: boolean = false;
  error1: boolean = false;
  succesmessage: boolean = false;
  notAccount: boolean = false;
  lastname: any;
  firstname: any;
  confirm: boolean = false;
  succesmessageDepot: boolean = false;
  errorD1: boolean = false;
  errorD4: boolean = false;
  errorD3: boolean = false;
  errorR4: boolean;
  errorR3: boolean;
  errorR1: boolean;
  succesmessageR: boolean;
  pendingValidationAchat: boolean = false;
  pendingValidationDepot: boolean = false;
  pendingValidationRetrait: boolean = false;
  accountid: string;
  accountBalance: any;
  bdepot: any;
  bretrait: any;
  depotInit: any;
  sigle: string;
  soldeOnline: any;
  isPatron: boolean = false;
  error6: boolean;
  error7: boolean;
  propritiesFirstnameLastname: any;
  private balanceSubscription?: Subscription;
  private businessAccountNumber: string | null = null;


  constructor(
    private userService: PayService,
    private userSessionService: UserSessionService,
    private balanceSyncService: BalanceSyncService,
    private realtimeBalanceService: RealtimeBalanceService
  ) {


  }

  ngOnInit(): void {

    this.accountid = localStorage.getItem("accountid");
    if (this.accountid != null) {
      this.isPatron = true;
    }
    this.username = this.userSessionService.getUser()?.username || '';
    this.sigle = this.userSessionService.getSigle();
    this.ngTransaction();
    this.ngDeposit();
    this.ngRetrait();
    this.subscribeToRealtimeBalances();
    this.getcompteBussinessinfo();
  }

  ngOnDestroy(): void {
    this.balanceSubscription?.unsubscribe();
  }

  getcompteBussinessinfo() {
    this.userService.getcompteBussiness(this.accountid).subscribe(data => {
      this.businessAccountNumber = data['accountNumber'] ?? this.businessAccountNumber;
      this.accountBalance = data['accountBalance'];
      this.bdepot = data['bdepot'];
      this.bretrait = data['bretrait'];
      this.depotInit = data['depotInit'];
      this.soldeOnline = data['soldeOnline'];
    })
  }

  ngTransaction() {
    this.transaction = new UntypedFormGroup(
      {
        montant: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
        pincode: new UntypedFormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
        username: new UntypedFormControl('')
      })
  }
  ngDeposit() {
    this.deposit = new UntypedFormGroup(
      {
        montant: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
        compte: new UntypedFormControl('', [Validators.required, Validators.pattern('([0-9]{9})$')])

      })
  }

  ngRetrait() {
    this.retrait = new UntypedFormGroup(
      {
        montantRetrait: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
        codeRetrait: new UntypedFormControl('', [Validators.required, Validators.pattern('([0-9]{4})$')])

      })
  }

  ontransaction(formdata: any) {

    const payload: CaissePrelevement = {
      caissierUsername: this.username,
      pincode: formdata.pincode,
      bussnessaccoundid: this.accountid ? Number(this.accountid) : -1,
      montantPrelevement: formdata.montant
    };
    console.log("Payload Component Bspace************************:", payload);
    this.userService
      .prelevementCompteclient(payload)
      .subscribe(data => {

        // reset erreurs
        this.error1 = this.error2 = this.error3 = this.error4 = false;
        this.pendingValidationAchat = false;

        if (data === 0) {
          this.succesmessage = true;
          this.refreshBalances();
          setTimeout(() => this.succesmessage = false, 4000);
        }
        else if (data === -1) {
          this.error1 = true; // PIN inexistant
          setTimeout(() => this.error1 = false, 4000);
        }
        else if (data === -2) {
          this.error2 = true; // solde insuffisant
          setTimeout(() => this.error2 = false, 4000);
        }
        else if (data === -3) {
          this.error3 = true; // compte bloqué
          setTimeout(() => this.error3 = false, 4000);
        }
        else if (data === -4) {
          this.error4 = true; // autre erreur métier
          setTimeout(() => this.error4 = false, 4000);
        }
        else if (data === -6) {
          this.error6 = true; // PIN expiré
          setTimeout(() => this.error6 = false, 4000);
        }
        else if (data === -7) {
          this.error7 = true; // PIN déjà utilisé
          setTimeout(() => this.error7 = false, 4000);
        }
        else if (data === -11) {
          this.pendingValidationAchat = true;
          setTimeout(() => this.pendingValidationAchat = false, 6000);
        }

      });
  }


  makeDeposit(formdata: any) {
    if (this.accountid == null) {
      this.accountid = "-1";
    }

    // Construction du payload conforme à CaisesseDepot
    const payload: CaisseDepot = {
      montant: formdata.montant,
      accountNumberBeneficiaire: Number(formdata.compte),
      caissierUsername: this.username,
      bussnessaccoundid: Number(this.accountid)
    };
    console.log("Payload Component Bspace - Dépôt************************:", payload);

    this.userService.depotClient(payload).subscribe(data => {
      this.pendingValidationDepot = false;

      if (data === 0) {
        this.succesmessageDepot = true;
        this.refreshBalances();
        setTimeout(() => this.succesmessageDepot = false, 4000);
      }
      else if (data === -1) {
        this.errorD1 = true;
        setTimeout(() => this.errorD1 = false, 4000);
      }
      else if (data === -2) {
        // ne doit pas arriver
      }
      else if (data === -3) {
        this.errorD3 = true;
        setTimeout(() => this.errorD3 = false, 4000);
      }
      else if (data === -4) {
        this.errorD4 = true;
        setTimeout(() => this.errorD4 = false, 4000);
      }
      else if (data === -11) {
        this.pendingValidationDepot = true;
        setTimeout(() => this.pendingValidationDepot = false, 6000);
      }

    });
  }


  makeRetrait(formdata) {
    if (this.accountid == null) {
      this.accountid = "-1";
    }
    this.userService.retraitClient(formdata, this.username, this.accountid).subscribe(data => {
      this.pendingValidationRetrait = false;
      if (data == 0) {
        this.succesmessageR = true;
        this.refreshBalances();
        setTimeout(() => {
          this.succesmessageR = false;
        }, 4000);
      }
      else if (data == -1) {
        this.errorR1 = true;
        setTimeout(() => {
          this.errorR1 = false;
        }, 4000);
      }
      else if (data == -2) {
        // ceci ne doit pas arriver
      }
      else if (data == -3) {
        this.errorR3 = true;
        setTimeout(() => {
          this.errorR3 = false;
        }, 4000);
      }
      else if (data == -4) {
        this.errorR4 = true;
        setTimeout(() => {
          this.errorR4 = false;
        }, 4000);
      }
      else if (data == -11) {
        this.pendingValidationRetrait = true;
        setTimeout(() => {
          this.pendingValidationRetrait = false;
        }, 6000);
      }

    })


  }

  checkAccount(value) {
    this.userService.getAccountInformation(value).subscribe(data => {
      this.firstname = "";
      this.lastname = "";
      if (data == null) {
        this.notAccount = true;
        this.confirm = false;
        setTimeout(() => {
          this.notAccount = false;
        }, 4000);
      }
      else {
        this.confirm = true;
        this.propritiesFirstnameLastname = data['utilisateurFullName']

      }
    })
  }

  TransfererVersSoldeInitial() {
    this.userService.maketransfertVersSoldeInitial(this.accountid).subscribe(data => {
      if (data == 0) {
        this.refreshBalances();
        // $("#controle-tab").trigger('click');
      }
    })
  }

  private refreshBalances() {
    this.balanceSyncService.syncNow().pipe(take(1)).subscribe({
      next: () => this.getcompteBussinessinfo(),
      error: () => this.getcompteBussinessinfo()
    });
  }

  private subscribeToRealtimeBalances() {
    this.balanceSubscription = this.realtimeBalanceService.balanceMessages$.subscribe(message => {
      if (!this.isCurrentBusinessBalanceMessage(message)) {
        return;
      }

      if (!this.hasBusinessSnapshot(message)) {
        this.getcompteBussinessinfo();
        return;
      }

      this.applyRealtimeBalanceUpdate(message);
    });
  }

  private isCurrentBusinessBalanceMessage(message: BalanceSocketMessage): boolean {
    if (!message || message.eventType !== 'BALANCE_CHANGED') {
      return false;
    }
    if (message.ownerType !== 'BUSINESS_ACCOUNT' && message.ownerType !== 'MICROFINANCE') {
      return false;
    }

    const currentOwnerId = Number(this.accountid);
    if (Number.isFinite(currentOwnerId) && currentOwnerId > 0 && message.ownerId === currentOwnerId) {
      return true;
    }

    return !!this.businessAccountNumber
      && !!message.accountNumber
      && message.accountNumber === this.businessAccountNumber;
  }

  private hasBusinessSnapshot(message: BalanceSocketMessage): boolean {
    return message.accountBalance != null
      || message.depotInit != null
      || message.bdepot != null
      || message.bretrait != null
      || message.soldeOnline != null;
  }

  private applyRealtimeBalanceUpdate(message: BalanceSocketMessage) {
    if (message.accountNumber) {
      this.businessAccountNumber = message.accountNumber;
    }
    if (message.accountBalance != null) {
      this.accountBalance = message.accountBalance;
    }
    if (message.bdepot != null) {
      this.bdepot = message.bdepot;
    }
    if (message.bretrait != null) {
      this.bretrait = message.bretrait;
    }
    if (message.depotInit != null) {
      this.depotInit = message.depotInit;
    }
    if (message.soldeOnline != null) {
      this.soldeOnline = message.soldeOnline;
    }
  }
  get montant() { return this.deposit.get('montant'); }
  get compte() { return this.deposit.get('compte'); }
  get montantRetrait() { return this.retrait.get('montantRetrait'); }
  get codeRetrait() { return this.retrait.get('codeRetrait'); }

}
